<template>
  <div class="tab_content tab__more_information">
    <!-- form - discount status-->
    <div class="vx-row px-5">
      <!-- col - 1 -->
      <div class="vx-col w-full">
        <div class="grid md:grid gap-4">
          <div class="mb-2 w-full flex items-center" v-for="(item, index) in customerStatus" :key="index">
            <label for="name" class="text-base font-bold">{{ item.customer_status_name }}</label>
            <vs-checkbox v-model="form.customerStatusIds" :id="item.id" :vs-value="item.id" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Select2 from '@/components/custom/form-elements/Select2.vue'

export default {
  name: 'DiscountStatusTab',
  components: {
    Select2
  },
  props: {
    form: {
      type: Object
    }
  },

  data: () => ({
    citiesOptions: [],
    loading: false
  }),

  async mounted() {
    await this.getCustomerStatusOptions() // get discount and tax options
  },

  computed: {
    ...mapState('discount', ['customerStatus']),

    // customer status type options
    customerStatusOptions() {
      return this.customerStatus.reduce((acc, item) => {
        acc.push({
          label: item.customer_status_name,
          value: item.id,
          status: false
        })

        return acc
      }, [])
    },

    customerStatusTypeoptions() {
      return this.customerStatus.reduce((acc, item) => {
        acc.push({
          status: item.value,
          customerStatusIds: item.value
        })
        return acc
      }, [])
    }
  },

  methods: {
    ...mapActions({ fetch_city_options: 'getCityOptions' }),
    ...mapActions('discount', ['getSystemCustomerStatus']),

    async getCustomerStatusOptions() {
      const payload = { page: 1, limit: 0, search: null }
      await this.getSystemCustomerStatus(payload)
    },

    // get city options
    async get_cities_options() {
      this.loading = true
      try {
        const { data } = await this.fetch_city_options({ search: '' })
        this.citiesOptions = data
        this.loading = false
      } catch ({ message }) {
        this.loading = false
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    }
  }
}
</script>
